import React from 'react';
import styled from 'styled-components';
import { IconButton, Tooltip } from '@material-ui/core';
import { MultilineChart } from '@material-ui/icons';
import { BORDER, GREY_TEXT } from '../AnalyticsV2.styled';

const Button = styled(IconButton)`
  &.MuiIconButton-root {
    padding: 3px;
    border-radius: 4px;
    border: 1px solid
      ${({ $color, $isSelected }) => ($isSelected ? $color : BORDER)};
    background: ${({ $color, $isSelected }) =>
      $isSelected ? $color : '#ffffff'};
    color: ${({ $isSelected }) => ($isSelected ? '#ffffff' : GREY_TEXT)};
  }
  &.MuiIconButton-root.Mui-disabled {
    color: #ffffff;
  }
  .MuiSvgIcon-root {
    font-size: 18px;
  }
`;

// 16px of invisible space around the button that also hovers and clicks it.
// The negative margin keeps the tile's layout as it was without the space.
const HitArea = styled.span`
  display: inline-flex;
  padding: 16px;
  margin: -16px;
  cursor: ${({ $isLocked }) => ($isLocked ? 'default' : 'pointer')};
  &:hover .MuiIconButton-root:not(.Mui-disabled) {
    background: ${({ $color, $isSelected }) =>
      $isSelected ? $color : '#f4f5f7'};
  }
`;

// The graph icon in a tile's top right corner. Clicking it adds the tile's
// metric to the graph or removes it; the click does not reach the tile, so
// the tile's drawer does not open. isLocked: the metric is the only one on
// the graph, so it can't be removed.
const GraphToggle = ({ label, color, isSelected, isLocked, onToggle }) => (
  <Tooltip title={isLocked ? 'At least one stat is shown on the graph' : ''}>
    {/* The hit area handles the click, so a click on the button or the space
        around it toggles the metric. It also keeps the tooltip working while
        the button is disabled. */}
    <HitArea
      $color={color}
      $isSelected={isSelected}
      $isLocked={isLocked}
      onClick={event => {
        event.stopPropagation();
        if (!isLocked) onToggle();
      }}
    >
      <Button
        aria-label={`${isSelected ? 'Remove' : 'Add'} ${label} on the graph`}
        aria-pressed={isSelected}
        $color={color}
        $isSelected={isSelected}
        disabled={isLocked}
      >
        <MultilineChart />
      </Button>
    </HitArea>
  </Tooltip>
);

export default GraphToggle;
